import { isReservedSlug } from './reservedSlugs';

/**
 * The path of a member's profile: `/<login>`, or `/u/<login>` when their Twitch
 * @ is a word the site keeps for itself. Every link to a profile (copy link, the
 * canonical tag, "View my page") goes through here.
 */
export function profileUrl(login: string): string {
  const l = login.toLowerCase();
  return isReservedSlug(l) ? `/u/${l}` : `/${l}`;
}
